var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"find"},[_c('ul',_vm._l((_vm.bookmarks),function(b,i){return _c('li',{key:i,class:{ selected: i == _vm.selected }},[_c('a',{attrs:{"href":b.url}},[_vm._v(_vm._s(b.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }